export default __webpack_public_path__ + "static/btn-wup-white-6d1f60468ae675b1859974a02b3e40ec.png";